import ApiResourceManager from '../ApiResourceManager';

export default class CustomersManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/customers',
      responseType: params?.format === 'csv' ? 'blob' : 'json',
      params,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/customers/${id}`,
    });

  getCashbackOperations = (id, params) =>
    this.request({
      method: 'GET',
      url: `/customers/${id}/cashback-operations`,
      params,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/customers/${id}`,
      data,
    });

  getCount = () =>
    this.request({
      method: 'GET',
      url: '/customers/count',
    });

  import = (data) =>
    this.request({
      method: 'POST',
      url: '/customers/import',
      data,
    });
}
